import { Separator } from "@gigpro/ui/Separator";
import { useBreakpoint } from "@gigpro/ui/utils/useBreakpoint";
import { ProProfile } from "domains/pros/views/ProProfile";
import { AiInterviewInviteCard } from "./AiInterviewInvite/AiInterviewInviteCard";
import { AdminCertificationsContainer } from "./Certifications";
import { InterviewRating } from "./InterviewRating";
import { OnboardingSteps } from "./OnboardingSteps";
import { AddNoteForm, ProNotesView } from "./ProNotes";

type OverviewProps = { proId: number };

export function Overview({ proId }: Readonly<OverviewProps>) {
  const isDesktop = useBreakpoint("md");

  const topSection = (
    <>
      <OnboardingSteps proId={proId} />
      <AddNoteForm proId={proId} />
      <Separator />
      <ProNotesView proId={proId} />
    </>
  );
  return (
    <div className="flex flex-1 flex-col rounded-b bg-white md:min-h-0 md:flex-row">
      {!isDesktop && (
        <>
          <div className="flex flex-col gap-3 py-3">{topSection}</div>
          <Separator />
        </>
      )}
      <ProProfile proId={proId} admin className="min-h-0 md:flex-1/3 md:overflow-auto" />
      <Separator className="md:hidden" />
      <Separator orientation="vertical" className="my-auto hidden h-[95%] md:block" />
      <div className="flex flex-col gap-4 px-2 py-4 md:flex-2/3 md:scrollbar-gutter-stable md:overflow-auto md:px-4">
        {isDesktop && topSection}
        {isDesktop && <Separator />}
        <AiInterviewInviteCard proId={proId} />
        <Separator />
        <h2 className="text-large font-semibold">Skill Certificates</h2>
        <AdminCertificationsContainer proId={proId} />
        <Separator />
        <InterviewRating proId={proId} />
      </div>
    </div>
  );
}
